<template>
  <section class="payment">
        <!--首页导航-->
        <nav class="payment_nav">
          <a href="javascript:;" class="payment_item" @click="gotoPayment('/cardnumpayment')">
            <div class="item item_icon">
              <img src="./images/CardNumber.png" alt="">
            </div>
            <div class="item">
              <p class="title">热力卡号缴费</p>
              <p>输入热力卡号查询数据库中热用户房屋面积，轻松完成采暖费缴纳</p>
            </div>
          </a>
          <a href="javascript:;" class="payment_item" @click="gotoPayment('/addresspayment')">
            <div class="item item_icon">
              <img src="./images/adress.png" alt="">
            </div>
            <div class="item">
              <p class="title">房屋地址缴费</p>
              <p>输入房屋地址查询数据库中热用户房屋面积，轻松完成采暖费缴纳</p>
            </div>
          </a>
          <!-- <a href="javascript:;" class="payment_item" @click="gotoPayment('/householdpayment')">
            <div class="item item_icon">
              <img src="./images/Household.png" alt="">
            </div>
            <div class="item">
              <p class="title">分户计量缴费</p>
              <p>收费采取两部制计费，</p>
              <p>总费用=基础费+流量费</p>
            </div>
          </a> -->
          <!--<a href="javascript:;" class="payment_item" @click="gotoPayment('/freedompayment')">-->
            <!--<div class="item item_icon">-->
              <!--<img src="./images/freedom.png" alt="">-->
            <!--</div>-->
            <!--<div class="item">-->
              <!--<p class="title">自助信息填写缴费</p>-->
              <!--<p>未查到用户信息的，可自主 填写上报完成缴费，</p>-->
            <!--</div>-->
          <!--</a>-->
        </nav>
      </section>
</template>

<script>
  import { Toast } from 'vant';import store from '../../store';
	export default {
	  name:'payment',
	  methods:{
	    //跳转各种缴费路由
      gotoPayment(path,name){
      //     Toast.fail({message:'暂未开放缴费！',className:'apiLoading'});
		  // return
        if(path=='/freedompayment'){
          Toast.fail({message:'暂未开放，请用其他方式缴费！',className:'apiLoading'});
        }else{
          this.$router.push({
            path:path,
            name:path.substring(1)
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
@import "../../common/stylus/mixins.styl"
  .payment
    .payment_nav
      width 100%
      height 100%
      padding-top 15px
      .payment_item
        display flex;
        display -webkit-flex;
        height 115px
        padding 35px 50px
        margin 30px 30px
        background #ffffff
        border-radius 20px 20px
        .item
          justify-content space-around
        .title
          font-size 30px
          color #333333
        img
          width 120px
          height 120px
          margin-right 50px
        p
          padding 5px 0px
          line-height 30px
</style>



// WEBPACK FOOTER //
// src/pages/Payment/Payment.vue